import { __assign, __decorate, __extends, __metadata } from "tslib";
import React from "react";
import { injectable } from "inversify";
import { IconFactory } from "./IconFactory";
/** Icon factory supporting font-awesome string, as well as the font-awesome icon definition and component. */
var FontAwesomeIconFactory = /** @class */ (function (_super) {
    __extends(FontAwesomeIconFactory, _super);
    /**
     * Creates a font awesome factory, allowing the use of IconDefinition on any neo icon prop.
     * @param fontAwesomeComponentType import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
     */
    function FontAwesomeIconFactory(fontAwesomeComponentType) {
        var _this = _super.call(this) || this;
        _this.fontAwesomeComponentType = fontAwesomeComponentType;
        return _this;
    }
    FontAwesomeIconFactory.prototype.createIconComponent = function (iconComponent, iconStyle) {
        if (iconComponent.iconName) {
            // Icon was specified using a font-awesome icon descriptor, return the font-awesome icon component.
            return React.createElement(this.fontAwesomeComponentType, {
                icon: iconComponent,
                fixedWidth: iconStyle === null || iconStyle === void 0 ? void 0 : iconStyle.fixedWidth,
                spin: iconStyle === null || iconStyle === void 0 ? void 0 : iconStyle.spin
            });
        }
        else {
            // Icon was specified as a font-awesome component. Extract the props, and override using the requested style.
            var props = __assign({}, iconComponent.props);
            if (iconStyle === null || iconStyle === void 0 ? void 0 : iconStyle.fixedWidth) {
                props.fixedWidth = iconStyle.fixedWidth;
            }
            if (iconStyle === null || iconStyle === void 0 ? void 0 : iconStyle.spin) {
                props.spin = iconStyle.spin;
            }
            return React.createElement(iconComponent.type, props);
        }
    };
    FontAwesomeIconFactory = __decorate([
        injectable(),
        __metadata("design:paramtypes", [Function])
    ], FontAwesomeIconFactory);
    return FontAwesomeIconFactory;
}(IconFactory));
export { FontAwesomeIconFactory };
